/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RoutineType } from "./RoutineType";
export const UpdateRoutineRequest = core.serialization.object({
    name: core.serialization.string(),
    config: core.serialization.any(),
    ordinal: core.serialization.number(),
    type: RoutineType,
});
